import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, ReplaySubject, Subject } from 'rxjs';

import { WorkShiftsService } from '../work-shifts/work-shifts.service';

@Injectable({
  providedIn: 'root',
})
export class WorkShiftService {
  private sectorData;
  private currentSectorData: any = {};
  public filterCollapse$ = new Subject();
  constructor(
    private http: HttpClient,
    private workShiftsService: WorkShiftsService
  ) {
    this.sectorData = <ReplaySubject<any>>new ReplaySubject(null);
  }

  public subscribeSectorData(): Observable<any> {
    return this.sectorData.asObservable();
  }

  public setSectorData(data: any): void {
    const nextData = data || {};
    const isSameSector =
      this.currentSectorData.sector_id &&
      nextData.sector_id &&
      Number(this.currentSectorData.sector_id) === Number(nextData.sector_id);

    this.currentSectorData = isSameSector ? Object.assign({}, this.currentSectorData, nextData) : Object.assign({}, nextData);
    this.sectorData.next(this.currentSectorData);
  }

  getPlots(u_id, params) {
    return this.workShiftsService.getWorkShiftsSectors(u_id, params);
  }

  getInitDataUnion(u_id, params) {
    const plots = this.getPlots(u_id, params);

    return forkJoin([plots]);
  }
}
